import React, { ForwardedRef, useContext } from 'react';
import { OriginIconProps } from '../type';
import { Context } from '../context';

function IconSavedComponent(props: OriginIconProps, ref: ForwardedRef<SVGSVGElement>) {
    const { prefix: prefixFromContext } = useContext(Context);
    const { className = '', prefix: prefixFromProps, width = '1em', height = '1em', useCurrentColor = true, spin, ...rest } = props;

    const prefix = prefixFromProps || prefixFromContext || 'alliance';
    const loadingKls = spin ? ` ${prefix}-icon-loading` : '';
    return <svg className={`${prefix}-icon ${prefix}-icon-Saved${loadingKls} ${className}`} width={width} height={height} viewBox="0 0 16 16" fill={useCurrentColor ? 'currentColor' : '#000'} xmlns="http://www.w3.org/2000/svg" {...rest} ref={ref}><path d="M2.21992 2.84945C3.81957 1.23869 6.3383 1.24767 7.99915 3.02732C9.65999 1.24767 12.1787 1.23869 13.7784 2.84945C15.4049 4.48733 15.4049 7.14076 13.7784 8.77863L8.45086 14.1432C8.33139 14.2635 8.16878 14.3311 7.99914 14.3311C7.82951 14.3311 7.6669 14.2635 7.54743 14.1432L2.21992 8.77863C0.593359 7.14076 0.593359 4.48733 2.21992 2.84945Z" fillOpacity="1"/></svg>;
}

const IconSaved = React.forwardRef(IconSavedComponent);
export default IconSaved;
